// extracted by mini-css-extract-plugin
export default {"changeDisclaimer":"RL-z","cltLink":"SL-z","shippingDisclaimer":"TL-z"};